import {MapLayerColor} from "../../enums";
import {LABELING_INFO_SYMBOL} from "../map";

export const DIBUJOS_SYMBOLS = {
  fill: {
    type: 'simple-fill',
    color: MapLayerColor.dibujosFill,
    style: 'solid',
    outline: {
      color: MapLayerColor.dibujosOutline,
      width: 1
    }
  },
  line: {
    type: 'simple-line',
    color: 'blue',
    width: '1px',
    style: 'short-dot'
  },
  marker: {
    type: 'simple-marker',
    outline: {
      width: '1px',
      color: [255, 255, 255, 0.99]
    },
    color: 'blue'
  },
  text: LABELING_INFO_SYMBOL
};

export const CIRCLE_SYMBOLS = {
  line: {
    type: 'simple-line',
    style: 'dash',
    width: 1,
    color: MapLayerColor.dibujosFill,
  },
  marker: {
    type: 'simple-marker',
    outline: {width: 1.5, color: [255, 255, 255, 0.99]},
    color: [0, 255, 255, 0.5]
  },
  text: LABELING_INFO_SYMBOL
};
